import { modifier } from "ember-modifier";

/** A focused number input changes its value on wheel. Blurring it lets the page scroll instead. */
export default modifier(
  (element: HTMLInputElement, [enabled = true]: [boolean | undefined]) => {
    if (!enabled || element.type !== "number") return;

    const blur = () => {
      if (document.activeElement === element) element.blur();
    };

    element.addEventListener("wheel", blur, { passive: true });

    return () => element.removeEventListener("wheel", blur);
  }
);
